import React, { Component } from 'react';
import Util from './Util.js';

class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      WelcomeInfo: this.props.i18n.welcome
    };
  }

  componentWillMount() {
  }

  onVisitGitHub() {
    dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'GitHub Project', 'eventAction': 'GitHub Project', 'eventLabel': 'Forward to GitHub Project' });
  }

  render() {
    let WelcomeInfo = this.state.WelcomeInfo;
    let subTitle = { __html: WelcomeInfo ? WelcomeInfo.introduction.subTitle : "" };
    let highlightItems = WelcomeInfo ? WelcomeInfo.highlights.items.map((itemGroup, groupIndex) =>
      <ul key={groupIndex}>
        {itemGroup.map((item, index) => <li key={index}><div className={item.icon} aria-hidden="true"></div><div className="highlight_text">{item.text}</div></li>)}
      </ul>
    ) : "";

    return (WelcomeInfo &&
      <div className={this.props.menuIsShow ? "welcome" : "welcomeWidth"}>
        <div className="introduction">
          <div className="mainTitle">{WelcomeInfo.introduction.mainTitle}</div>
          <div className="subTitle" dangerouslySetInnerHTML={subTitle}></div>
          <div className="gitLink">
            <i className="fa fa-github" aria-hidden="true"></i>
            <a target="_blank" href={this.props.i18n.githubLink} onClick={this.onVisitGitHub}>
              {this.props.i18n.github}
            </a>
          </div>
          <br />
        </div>
        <div className="highlights">
          <div className="highlight_title">{WelcomeInfo.highlights.title}</div>
          <div className="highlight_items">
            {highlightItems}
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;